import React, { PureComponent } from 'react';
import ld from 'lodash';
import { List } from 'immutable';
import { bindActionCreators } from '../../app.store.jsx';
import { AjaxAutocomplete } from '../autocomplete/autocomplete.jsx';
import TextInput from '../text.input/text.input.jsx';
import { setAutocompleteText } from '../autocomplete/reducer.jsx';
import DropDown from '../dropdown/dropdown.jsx';
import NumberInput from '../number.input/number.input.jsx';
import CANCER_LIST from '../../config/cancer.list.jsx';
import _ from '../../i18n.jsx';
import { getPropsOrDefault, isEmptyValue, KEY_CODES } from '../../../common/utils.jsx';
import { FCH_COMPONENT_PATH, NAME_FIELD_NAME, CANCER_LIST_FIELD_NAME, SINGLE_PERSON_FIELDS,
    relativesDescription, createNewCancerItem, updateFCHField, updateFCHPersonRelation,
    removeRelative, createPerson, removeCancerItem, bindPerson } from './reducer.jsx';
import style from './family.cancer.history.jsx.less';
import { EMPTY_STRING, EMPTY_ARRAY } from '../../questionnaire.utils.jsx';
import classNames from 'classnames';

const relationsDropDownOptions = ld.map(relativesDescription, ({ title }, relationName) => {
    return { name: title, value: relationName };
});

class CancerFieldItem extends PureComponent {
    constructor() {
        super();
        this._updateFCHField = bindActionCreators(updateFCHField);
        this._removeCancerItem = bindActionCreators(removeCancerItem);
        this._setAutocompleteText = bindActionCreators(setAutocompleteText);
        this.updateCancerName = this.updateCancerName.bind(this);
        this.updateAge = this.updateAge.bind(this);
        this.removeItem = this.removeItem.bind(this);
        this.keyDownHandler = this.keyDownHandler.bind(this);
        this.getAutocompleteName = this.getAutocompleteName.bind(this);
    }

    updateCancerName(name, newValue) {
        const { id, cancerIndex, value } = this.props;
        const splitedValues = value.split(/\s?,\s?/);
        let age = EMPTY_STRING;
        if (1 < splitedValues.length) {
            age = splitedValues.pop();
        }
        this._updateFCHField(id, [ CANCER_LIST_FIELD_NAME, cancerIndex ], `${newValue}, ${age}`);
    }
    updateAge(event) {
        const { id, cancerIndex, value } = this.props;
        const splitedValues = value.split(/\s?,\s?/);
        let cancer = EMPTY_STRING;
        if (1 < splitedValues.length) {
            splitedValues.pop();
            cancer = splitedValues.join(', ');
        }
        this._updateFCHField(id, [ CANCER_LIST_FIELD_NAME, cancerIndex ], `${cancer}, ${event.target.value}`);
    }
    getAutocompleteName() {
        const { id, cancerIndex } = this.props;
        return `relative-${id}-${cancerIndex}`;
    }
    removeItem() {
        const { id, cancerIndex } = this.props;
        this._setAutocompleteText(this.getAutocompleteName(), EMPTY_STRING);
        this._removeCancerItem(id, cancerIndex);
    }
    keyDownHandler(event) {
        const { keyCode } = event;
        if (KEY_CODES.SPACE === keyCode || KEY_CODES.ENTER === keyCode) {
            this.removeItem();
            event.preventDefault();
        }
    }
    render() {
        const { value, enableDeleteBtn, components, showAll, disabled } = this.props;
        const splitedValues = value.split(/\s?,\s?/);
        let age = EMPTY_STRING,
            cancer = EMPTY_STRING;
        if (1 < splitedValues.length) {
            age = splitedValues.pop();
            cancer = splitedValues.join(', ');
        }
        const defaultCancerName = CANCER_LIST.find((item) => cancer === item.value);
        if (defaultCancerName) { cancer = defaultCancerName.name; }
        return (
            <li className={style.cancerItem}>
                <AjaxAutocomplete name={this.getAutocompleteName()} components={components} value={cancer} disabled={disabled}
                    id={this.getAutocompleteName()} variants={CANCER_LIST} onChangeCallback={this.updateCancerName} cssWrapperClass={style.autocompleteWrapper} showAll={showAll}/>
                <NumberInput onChangeCallback={this.updateAge} disabled={disabled} length="3"
                    value={age} name="age" wrapperClass={style.numberInputWrapper} cssClass={style.numberInput}/>
                {
                    enableDeleteBtn
                    ? <div className={style.btnDelete} onClick={this.removeItem}>
                        <a className={style.iconDeleteCancerItem} onKeyDown={this.keyDownHandler} tabIndex={disabled ? -1 : 0}></a>
                      </div>
                    : null
                }
            </li>
        );
    }
}

export class CancerFieldsList extends PureComponent {
    constructor() {
        super();
        this._createNewCancerItem = bindActionCreators(createNewCancerItem);
        this._updateFCHField = bindActionCreators(updateFCHField);
        this.addCancerItem = this.addCancerItem.bind(this);
        this.keyDownHandler = this.keyDownHandler.bind(this);
    }

    addCancerItem() {
        this._createNewCancerItem(this.props.id);
    }
    keyDownHandler(event) {
        const { keyCode } = event;
        if (KEY_CODES.SPACE === keyCode || KEY_CODES.ENTER === keyCode) {
            this.addCancerItem();
            event.preventDefault();
        }
    }
    render() {
        const { CANCER_TYPE, AGE_OF_DIAG, ADD_NEW_CANCER } = CancerFieldsList.STRINGS;
        const { components, id, disabled } = this.props;
        let cancerList = this.props.cancerList;
        if (!ld.isArray(cancerList)) {
            // TODO: after logrocket will be enabled
            // send all info to logrocket when this case is triggered
            console.warn('Possible failed state: cancerList has invalid value ');
            console.warn({ value: cancerList, type: typeof cancerList });
            console.log('Recovering');
            this._updateFCHField(id, [CANCER_LIST_FIELD_NAME], new List(['']));
            cancerList = [''];
        }
        const enableDeleteBtn = 1 < cancerList.length;
        const cancerTypeClass = classNames(style.cancerLabel, style.cancerTypeLabel);
        const ageOfDiagnosisClass = classNames(style.cancerLabel, style.ageOfDiagnosisLabel);
        return (
            <div className={style.wrapper}>
                <div>
                    <label className={cancerTypeClass}>{CANCER_TYPE}</label>
                    <label className={ageOfDiagnosisClass}>{AGE_OF_DIAG}</label>
                </div>
                <ul className={style.cancerList} data-testid="cancer-list">
                    { cancerList.map((cancer, key) => <CancerFieldItem disabled={disabled} id={id} enableDeleteBtn={enableDeleteBtn} key={key} cancerIndex={key} value={cancer} components={components}/>) }
                </ul>
                <span className={style.addAnotherCancer} onClick={this.addCancerItem} tabIndex={disabled ? -1 : 0} onKeyDown={this.keyDownHandler}>
                    {ADD_NEW_CANCER}
                </span>
            </div>
        );
    }
}
CancerFieldsList.STRINGS = {
    CANCER_TYPE:    _('Cancer type'),
    AGE_OF_DIAG:    _('Age of diagnosis'),
    ADD_NEW_CANCER: _('Add another cancer type')
};

class PersonInfo extends PureComponent {
    constructor() {
        super();
        this._updateFCHField = bindActionCreators(updateFCHField);
        this._updateFCHPersonRelation = bindActionCreators(updateFCHPersonRelation);
        this._bindPerson = bindActionCreators(bindPerson);
        this.changeName = this.changeName.bind(this);
        this.changeRelation = this.changeRelation.bind(this);
        this.getNames = this.getNames.bind(this);
        this.getAvailableRelations = this.getAvailableRelations.bind(this);
    }

    changeName(name, value) {
        const SINGLE_SPACE = ' ';
        const splittedValues = value.split(SINGLE_SPACE);
        let personId = null;
        if (1 < splittedValues.length) { personId = splittedValues.pop(); }
        const fieldName = splittedValues.join(SINGLE_SPACE);
        let relationName = null;
        ld.find(relativesDescription, (relativeType, key) => {
            const isMatch = relativeType.field === fieldName;
            if (isMatch) { relationName = key; }
            return isMatch;
        });
        let _value = value;
        const internalId = this.props.id;
        if (null !== relationName) {
            const persons = this.getNames(this.getAvailableRelations());
            const personByRelation = ld.find(persons, { value: _value });
            if (personByRelation) {
                this._bindPerson(internalId, fieldName, personId);
                _value = personByRelation.name;
            }
        }
        this._updateFCHField(internalId, NAME_FIELD_NAME, _value);
    }
    changeRelation(name, value) {
        this._updateFCHPersonRelation(this.props.id, value);
    }
    getNames(availableRelations = []) {
        const { fieldValues } = this.props;
        const singleRelativesFields = [
            'mother', 'father',
            'paternal_grandfather', 'paternal_grandmother',
            'maternal_grandfather', 'maternal_grandfather'
        ];
        const multipleRelativesFiels = [
            'siblings', 'children', 'nephews', 'cousins',
            'mother_siblings', 'father_siblings'
        ];
        const names = [];
        singleRelativesFields.forEach((fieldName) => {
            const personName = getPropsOrDefault(fieldValues, `${fieldName}.name`, false);
            const relationAvail = undefined !== availableRelations.find(({ value }) => value === fieldName);
            if (personName && relationAvail) {
                names.push({ name: personName, value: fieldName });
            }
        });
        multipleRelativesFiels.forEach((fieldName) => {
            const persons = getPropsOrDefault(fieldValues, `${fieldName}.data`, false);
            if (false === persons) { return; }
            ld.forEach(persons, (person, id) => {
                const personName = person.name || EMPTY_STRING;
                const hasCancer = person.cancerList || false;
                if (isEmptyValue(personName) || hasCancer) { return; }
                names.push({ name: personName, value: `${fieldName} ${id}` });
            });
        });
        return names;
    }
    getAvailableRelations() {
        const { relation, components } = this.props;
        const registeredSingletoneRelatives = components[FCH_COMPONENT_PATH]
            .filter((person) => {
                const relationDesc = relativesDescription[person.relation];
                if (undefined === relationDesc) { return true; }
                const fieldName = relationDesc.field;
                return undefined !== SINGLE_PERSON_FIELDS[fieldName];
            })
            .map((person) => person.relation);
        const registeredSingletoneRelativesSet = new Set(registeredSingletoneRelatives);
        return relationsDropDownOptions.filter((item) => {
            return !registeredSingletoneRelativesSet.has(item.value) || (item.value === relation);
        });
    }
    render() {
        const { NAME, RELATIONSHIP } = PersonInfo.STRINGS;
        const { relation, id, components, name, showAll, disabled } = this.props;
        const relations = this.getAvailableRelations();
        const names = this.getNames(relations);
        const inputName = `relativeName-${id}`;
        return (
            <div className={style.personInfoWrapper}>
                <div className={style.personInfoAutocompleteWrapper}>
                    <label className={style.label}>{NAME}</label>
                    <TextInput id={inputName} name={inputName} components={components} variants={names} onChangeCallback={this.changeName}
                        cssWrapperClass={style.autocomplete} value={name} showAll={showAll} disabled={disabled}/>
                </div>
                <div className={style.dropdownWrapper}>
                    <label className={style.label}>{RELATIONSHIP}</label>
                    <DropDown onChangeCallback={this.changeRelation} value={relation} options={relations} cssDropdownClass={style.drowdown}
                        cssClassWrapper={style.personInfoDropdownWrapper} cssButtonClass={style.dropdownButton} className={style.relationDropdown} disabled={disabled}/>
                </div>
            </div>
        );
    }
}
PersonInfo.STRINGS = {
    NAME: _('Name'),
    RELATIONSHIP: _('Relationship')
};

class PersonItem extends PureComponent {
    constructor() {
        super();
        this.removeRelative = bindActionCreators(removeRelative);
        this.removeItem = this.removeItem.bind(this);
        this.keyDownHandler = this.keyDownHandler.bind(this);
    }

    removeItem() {
        this.removeRelative(this.props.id);
    }
    keyDownHandler(event) {
        const { keyCode } = event;
        if (KEY_CODES.SPACE === keyCode || KEY_CODES.ENTER === keyCode) {
            this.removeItem();
            event.preventDefault();
        }
    }
    render() {
        const { person, components, id, fieldValues, disabled } = this.props;
        let showDeleteBtn = false;
        const cancerListNotEmpty = person.cancerList && person.cancerList[0] && EMPTY_STRING === person.cancerList[0].trim();
        if (person.relation || person.__id || person.name || cancerListNotEmpty || 0 < id) {
            showDeleteBtn = true;
        }
        return (
            <div className={style.person}>
                <PersonInfo {...person} components={components} fieldValues={fieldValues} id={id} disabled={disabled}/>
                <CancerFieldsList cancerList={person.cancerList} components={components} id={id} disabled={disabled}/>
                {
                    showDeleteBtn
                    ? <div className={style.btnDelete} onClick={this.removeItem}>
                        <a className={style.iconDeletePerson} tabIndex={disabled ? -1 : 0} onKeyDown={this.keyDownHandler}></a>
                      </div>
                    : null
                }

            </div>
        );
    }
}

export default class FamilyCancerHistory extends PureComponent {
    constructor() {
        super();
        this._createPerson = bindActionCreators(createPerson);
    }

    render() {
        const { components, fieldValues, disabled } = this.props;
        const persons = components[FCH_COMPONENT_PATH] || EMPTY_ARRAY;
        return (
            <div>
                { persons.map((person, index) => <PersonItem key={index} disabled={disabled} id={index} person={person} fieldValues={fieldValues} components={components}/>) }
                <button disabled={disabled} onClick={this._createPerson} className={style.addRelativeBtn}>{ _('Add Relative') }</button>
            </div>
        );
    }
}
